export default function getTableId(tableQuery) {
    var tableId = [];
    switch (tableQuery.type) {
        case 0 /* Folder */:
            tableId.push('folderId:' + tableQuery.folderId);
            var mailTableQuery = tableQuery;
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('viewFilter:' + mailTableQuery.viewFilter);
            tableId.push('focusedViewFilter:' + mailTableQuery.focusedViewFilter);
            tableId.push('sortColumn:' + mailTableQuery.sortBy.sortColumn);
            tableId.push('sortDirection:' + mailTableQuery.sortBy.sortDirection);
            if (mailTableQuery.categoryName) {
                tableId.push('catName:' + mailTableQuery.categoryName);
            }
            break;
        case 1 /* Search */:
            tableId.push('folderId:' + tableQuery.folderId);
            var searchTableQuery = tableQuery;
            tableId.push('id:' + searchTableQuery.searchNumber);
            tableId.push('query:' + searchTableQuery.queryString);
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('scenarioType:' + searchTableQuery.scenarioType);
            break;
        case 2 /* Group */:
            tableId.push('groupId:' + tableQuery.folderId);
            var groupMailTableQuery = tableQuery;
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('viewFilter:' + groupMailTableQuery.viewFilter);
            break;
    }
    return tableId.join(';').toString();
}
//# sourceMappingURL=getTableId.js.map